import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface NameProps {
  name: string;
  url?: string;
  className?: string;
}

export function Name({name, url, className}: NameProps) {
  const resolvedClassName = className ?? DetailsTooltipStyles.EntityName;

  return (
    <h3 className={resolvedClassName}>
      {url ? (
        <TextLinkWidget href={url}>{name}</TextLinkWidget>
      ) : (
        <span>{name}</span>
      )}
    </h3>
    );
}